/* eslint-disable react-hooks/exhaustive-deps */
import { PlaidAccountData, usePlaidLinkToken } from '@melio/platform-api';
import { throttle } from 'lodash';
import { useEffect } from 'react';
import { PlaidLinkOnEvent, usePlaidLink } from 'react-plaid-link';

export type UsePlaidProps = {
  onSuccess: (data: PlaidAccountData) => void;
  onExit?: VoidFunction;
  onLoad?: VoidFunction;
  onError?: ErrorFunction;
};

export const usePlaid = ({ onError, onSuccess, onLoad, onExit }: UsePlaidProps) => {
  const { data, remove } = usePlaidLinkToken();

  useEffect(() => remove, []);

  // XXX standardize error codes and messages https://linear.app/meliopayments/issue/PLA-905
  const handleError = () => {
    onError?.({ code: '500', message: 'Could not create a bank account' });
    onExit?.();
  };

  return usePlaidLink({
    token: data?.linkToken || null,
    onLoad,
    onExit,
    onSuccess: (public_token, metadata) => onSuccess({ public_token, ...metadata }),
    // plaid sends duplicate error events we need to throttle in order to not get multiple toast messages
    onEvent: throttle<PlaidLinkOnEvent>(
      (name, data) => {
        if ((name === 'EXIT' && data.exit_status === 'requires_credentials') || data.error_code) {
          return handleError();
        }
        if (name === 'ERROR') {
          return handleError();
        }
      },
      100,
      { trailing: false }
    ),
  });
};
